import { create } from 'zustand';

interface FormEditorDialogState {
  openSections: string[];
  setOpenSections: (sections: string[]) => void;
  toggleSwitchSection: (value: string, checked: boolean) => void;
  /**
   * Field or section id the form editor list should bring into view the next
   * time it renders. The dialog body unmounts whenever the user steps into a
   * sub-editor, so scroll position can only be restored by re-anchoring on an
   * element id once the list is back on screen.
   */
  scrollAnchorId: string | null;
  requestScrollToAnchor: (id: string) => void;
  clearScrollAnchor: () => void;
}

export const useFormEditorDialogStore = create<FormEditorDialogState>(
  (set) => ({
    openSections: [],
    scrollAnchorId: null,
    requestScrollToAnchor: (id) => set({ scrollAnchorId: id }),
    clearScrollAnchor: () => set({ scrollAnchorId: null }),
    setOpenSections: (sections) => set({ openSections: sections }),
    toggleSwitchSection: (value, checked) =>
      set((state) => ({
        openSections: checked
          ? [...state.openSections, value]
          : state.openSections.filter((v) => v !== value),
      })),
  })
);
